import React from "react";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import { Button } from "aible";
import { LineInput } from "components/Inputs/LineInput";

import styles from "./style.module.css";

export default class BYOMModal extends React.PureComponent {
  constructor(props) {
    super(props);
    const externalModelExpected =
      this.props && this.props.expectedExternalModel && this.props.expectedExternalModel.expected;
    const initialName = externalModelExpected
      ? this.props.expectedExternalModel.expected.replace("external-classifier-", "")
      : undefined;

    this.state = {
      name: initialName,
      url: externalModelExpected ? "****" : undefined,
      username: externalModelExpected ? "****" : undefined,
      password: externalModelExpected ? "****" : undefined,
      modelAddedSuccessfully: false,
      isLoading: false,
      initialName: initialName
    };
  }

  render() {
    const { updateBYOM } = this.props;
    const { name, url, username, password } = this.state;

    const labelStyle = { width: "120px" };
    const invalidModelName = !!(this.state.name && /\s/.test(this.state.name));

    return (
      <div className={styles.selectDataAdvanced}>
        <div className={styles.BYOMHeader}>
          <div className={styles.BYOMHeaderInfoBox}>
            <div className={styles.BYOMHeaderInfoBoxText}>
              <div>Do you have a deployed model you would like to evaluate and monitor?</div>
              <div>
                Link to your third-party model here to evaluate it against Aible models and also monitor its
                performance.
              </div>
              {this.state.initialName && (
                <div style={{ marginTop: "10px" }}>
                  NOTE: You have already added the current model listed in the model name section below. The Model URL,
                  Username and Password are not displayed for security reasons and are safely stored in your cloud
                  account.
                </div>
              )}
            </div>
          </div>
        </div>
        <div className={styles.BYOMInstructions}>{"What model would you like to evaluate?"}</div>
        <LineInput
          isMediumBox
          labelStyle={labelStyle}
          label={"Model Name"}
          placeholder={"Enter Model Name"}
          value={name}
          onChange={(val) => this.setState({ name: val })}
        />
        {invalidModelName && (
          <div className={styles.BYOMInvalidNameWarning}>Please remove spaces from the model name.</div>
        )}
        <LineInput
          isMediumBox
          labelStyle={labelStyle}
          label={"Model URL"}
          placeholder={"Enter Model URL"}
          value={url}
          onChange={(val) => this.setState({ url: val })}
        />
        <LineInput
          isMediumBox
          labelStyle={labelStyle}
          label={"Username"}
          placeholder={"Enter username"}
          value={username}
          onChange={(val) => this.setState({ username: val })}
        />
        <LineInput
          isMediumBox
          labelStyle={labelStyle}
          label={"Password"}
          placeholder={"Enter password"}
          value={password}
          onChange={(val) => this.setState({ password: val })}
          isPassword
        />
        <div style={{ marginTop: "10px" }}>
          <Button
            type="primary"
            onClick={() => {
              this.setState({ isLoading: true });
              updateBYOM(this.state).then(() =>
                this.setState({
                  modelAddedSuccessfully: true,
                  isLoading: false
                })
              );
            }}
            disabled={
              name === undefined ||
              url === undefined ||
              username === undefined ||
              password === undefined ||
              invalidModelName ||
              this.state.modelAddedSuccessfully ||
              this.state.isLoading
            }
          >
            {this.state.isLoading ? (
              <LoadingIndicator
                style={{
                  width: "20px",
                  height: "18px",
                  transform: "scale(0.30)",
                  margin: "-5px 5px 5px -10px"
                }}
              />
            ) : this.state.modelAddedSuccessfully ? (
              "Model Added"
            ) : (
              "Add Model"
            )}
          </Button>
        </div>
      </div>
    );
  }
}
